import requestByGateway from '@/request/request.gateway';
import qs from 'qs';
import config from '@/config';
const applicationManagement = {
	/**-------------应用市场------------*/
	/**
	 * 获取应用列表
	 */
	getAppMaketList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/app-store/list`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 修改上线状态
	 */
	changeAppStatus(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/app-store/status-update`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 更新应用
	 */
	updateApp(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/app-store/update`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 添加应用
	 */
	publicApp(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/app-store/insert`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 获取应用详情
	 */
	getAppDetail(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/app-store/info`,
			headers: config.headers,
			params
		});
	},
	/*****************渠道应用配置*******************/
	/**
	 * 获取所有渠道列表
	 */
	getChannelList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/app-oem/list`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 获取渠道应用列表
	 */
	getChannelAppList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/app-channel/list`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 修改渠道应用的开通状态
	 */
	changeChannelAppStatus(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/app-channel/status-update`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 更新应用渠道
	 */
	updateChannelApp(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/app-channel/update-channel-app`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/*****************学校配置*********************/
	/**
	 * 获取学校列表
	 */
	getSchoolList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/app-oem/school-list`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 获取学校应用列表
	 */
	getSchoolAppList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/app-school/list`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 修改学校应用状态
	 */
	changeSchoolAppStatus(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/app-school/app-status-modify`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 获取范围列表
	 */
	getAreaList() {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/app-store/insert-page`,
			headers: config.headers
		});
	},
	/**
	 * 获取应用顺序列表
	 */
	getOrderList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/app-channel/get-app-order`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 更新应用顺序
	 */
	updateOrder(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/app-channel/set-app-order`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	}
};
export default applicationManagement;
